








































































































import {isMobile} from 'mobile-device-detect';
import Velocity from 'velocity-animate';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {
  MenuEntry,
  UrlStorage,
} from '../../../build/swagger-code-extranet-api-definition';
import ApplicationBarStoreModule from '../../store/modules/applicationBar.module';
import ExtranetConfigurationStoreModule from '../../store/modules/extranetConfiguration.module';
import NotificationCenterStoreModule from '../../store/modules/notificationCenter.module';
import QuickLinksStoreModule from '../../store/modules/quickLinks.module';
import UrlStorageModule from '../../store/modules/urlStorage.module';
import UserInfoStoreModule from '../../store/modules/userInfo.module';
import NotificationCenterItem from '../notificationCenter/NotificationCenterItem.vue';
import MobileNavigationBar from '../quickLinks/MobileNavigationBar.vue';
import BasketItem from './BasketItem.vue';
import BudgetOrdersItem from './BudgetOrdersItem.vue';
import MenuItem from './MenuItem.vue';
import UserItem from './UserItem.vue';
import Logo from '../menuBar/Logo.vue';

@Component({
  components: {
    Logo,
    NotificationCenterItem,
    MobileNavigationBar,
    'sch-application-bar-item': MenuItem,
    'sch-basket-item': BasketItem,
    'sch-user-item': UserItem,
    'sch-budget-orders-item': BudgetOrdersItem,
  },
})
export default class ApplicationBar extends Vue {
  applicationBarStore: ApplicationBarStoreModule = getModule(ApplicationBarStoreModule, this.$store);
  extranetConfigurationStore: ExtranetConfigurationStoreModule = getModule(ExtranetConfigurationStoreModule, this.$store);
  quickLinksStore: QuickLinksStoreModule = getModule(QuickLinksStoreModule, this.$store);
  notificationCenterStore: NotificationCenterStoreModule = getModule(NotificationCenterStoreModule, this.$store);
  userInfoStore: UserInfoStoreModule = getModule(UserInfoStoreModule, this.$store);
  urlStorageStore: UrlStorageModule = getModule(UrlStorageModule, this.$store);

  fallbackLanguage: string = 'de';
  fallbackCountry: string = 'AT';

  applicationBarLoaded: boolean = false;

  public urlStorage: UrlStorage = {};

  public get applicationBarStandaloneEnabled() {
    return this.applicationBarStore.applicationBarStandalone.enabled;
  }

  public get applicationStandaloneApplicationBar() {
    return this.applicationBarStore.applicationBarStandalone.content;
  }

  public data() {
    return {
      applicationBarFilterToggled: false,
      overflow: {},
      sideMenuOpened: false,
    };
  }

  public onSideMenuExpanding() {
    document.getElementById('sideMenuCollapse').setAttribute('expanding', '');
  }

  public onSideMenuExpanded() {
    document.getElementById('sideMenuCollapse').removeAttribute('expanding');
  }

  public calcElementWidth(el) {
    if (el.offsetWidth === 0) {
      const prevPosition = el.style.position;
      const prevTop = el.style.top;
      const prevDisplay = el.style.display;
      el.style.position = 'absolute'; // Calculate width outside of the window
      el.style.top = '-10000px';
      el.style.display = 'list-item';
      const width = el.offsetWidth;
      el.style.position = prevPosition;
      el.style.top = prevTop;
      el.style.display = prevDisplay;
      return width;
    }
    return el.offsetWidth;
  }

  public getComputedStyle(el) {
    return window.getComputedStyle(el, null);
  }

  public calcOverflow() {
    const ret = new Array(this.applicationBarStore.menuEntries.length);
    let lastOffset = 0;
    const navbar: HTMLElement = document.getElementById('applicationBarContainer');
    let usedWidth = 0;
    for (let i = 0; i < this.applicationBarStore.menuEntries.length; i++) {
      if (i > 0 && ret[i - 1]) {
        ret[i] = true;
        continue;
      }

      const el = document.getElementsByClassName(`applicationbar-element-${i}`)[0] as HTMLElement;
      const elWidth = this.calcElementWidth(el);
      const elOffset = el.offsetLeft === 0 ? lastOffset : el.offsetLeft;

      const button = document.getElementById('sideMenuToggler');
      const buttonStyle = getComputedStyle(button);
      const buttonWidth =
          this.calcElementWidth(button)
          + parseFloat(buttonStyle.getPropertyValue('margin-left'))
          + parseFloat(buttonStyle.getPropertyValue('margin-right'));
      const applicationBarRight = document.getElementById('applicationBarRight');
      const applicationBarRightStyle = getComputedStyle(applicationBarRight);
      const applicationBarRightWidth =
          this.calcElementWidth(applicationBarRight)
          + parseFloat(applicationBarRightStyle.getPropertyValue('margin-left'))
          + parseFloat(applicationBarRightStyle.getPropertyValue('margin-right'));
      const container = document.getElementById('applicationBarContainer');
      const containerStyle = getComputedStyle(container);
      const containerNonUsableSpace =
          parseFloat(containerStyle.getPropertyValue('padding-left'))
          + parseFloat(containerStyle.getPropertyValue('padding-right'));
      const maxWidth =
          navbar.clientWidth
          - buttonWidth
          - applicationBarRightWidth
          - containerNonUsableSpace;

      usedWidth += elWidth;
      ret[i] = usedWidth > maxWidth;
      lastOffset = elOffset + elWidth;
    }
    this.$data.overflow = ret;
  }

  public applicationbarElementsCount() {
    return Object.keys(this.$refs).filter((item) => item.startsWith('applicationbar-element-')).length;
  }

  get getOverflows() {
    return this.$data.overflow;
  }

  get anyOverflow() {
    const overflows = this.getOverflows;
    if (Object.keys(overflows).length === 0 && overflows.constructor === Object) {
      return false;
    }
    return overflows.some((item) => item);
  }

  get showNotificationCenter() {
    return this.extranetConfigurationStore.appBarConfiguration.enableNotificationCenter;
  }

  @Watch('applicationBarStore.menuEntries')
  @Watch('userInfoStore.userInfo')
  @Watch('applicationBarStore.basketSummaryForAllBaskets')
  public recalculateOverflow() {
    Vue.nextTick(() => {
      this.calcOverflow();
    });
  }

  @Watch('applicationBarStore.budgetOrdersSummary')
  public updateBudgetOrderQuickLink() {
    this.quickLinksStore.setHasBudgetOrdersPermission(this.applicationBarStore.budgetOrdersSummary.display);
    this.quickLinksStore.setBudgetOrdersCount(this.applicationBarStore.budgetOrdersSummary.budgetOrdersCount);
    this.recalculateOverflow();
  }

  public closeSideMenu() {
    this.$data.sideMenuOpened = false;
  }

  public toggleSideMenu() {
    const sideMenuNav = document.getElementById('sideMenuNav');
    Velocity(sideMenuNav, {width: sideMenuNav.clientWidth > 0 ? 0 : 250}, {duration: 300});
  }

  public async created() {
    if (!this.applicationBarStandaloneEnabled || !this.applicationStandaloneApplicationBar) {
        this.extranetConfigurationStore.loadAppBarConfiguration().then(() => {
          if (this.extranetConfigurationStore.appBarConfiguration.enableNotificationCenter) {
            this.notificationCenterStore.loadNotificationsSummary({
              userLanguage: this.fallbackLanguage,
              userCountry: this.fallbackCountry,
            });
            this.applicationBarStore.loadBudgetOrdersSummary();
          }
        });
        this.applicationBarStore.loadMenuEntries(this.$route.query);
        this.quickLinksStore.loadQuickLinks();
    }
    this.applicationBarStore.loadCompany();
    this.urlStorage = await this.urlStorageStore.loadUrls();
  }

  public async mounted() {
    if (this.applicationBarStandaloneEnabled && this.applicationStandaloneApplicationBar) {
      this.setApplicationBarStandaloneContentManuallyAsVHtmlDoesNotLoadScripts();
    } else {
      window.addEventListener('resize', () => {
        if (this.applicationbarElementsCount() < this.applicationBarStore.menuEntries.length) {
          return;
        }
        this.calcOverflow();
      });
      document.getElementById('sideMenuContainer').addEventListener('click', (event) => {
        if (event.target !== document.getElementById('sideMenuNav')) {
          this.toggleSideMenu();
          this.closeSideMenu();
        }
      });
    }
  }

  private setApplicationBarStandaloneContentManuallyAsVHtmlDoesNotLoadScripts() {
    document.getElementById('newAppBar').append(document.createRange().createContextualFragment(this.applicationStandaloneApplicationBar));
  }

  get showMobileNavigationBar() {
    return isMobile;
  }

  get userLoggedIn() {
    return !!this.userInfoStore.userInfo.username;
  }

  get loginMenuEntry(): MenuEntry {
    return {
      active: false,
      application: true,
      id: '-1',
      name: this.$t('extranetSecurity.pleaseLogin').toString(),
      priority: 1000,
      url: this.loginUrl,
    };
  }

  get loginUrl(): string {
    const currentUrl = encodeURIComponent(window.location.href);

    return `${this.urlStorage.login}?redirectUrl=${currentUrl}`;
  }

}
